module.exports = __webpack_public_path__ + "S_left.51037006.png";